import i18n from '../locales/index'
import store from '@/store';
import Login from '@/components/Login/index';
import { Message } from 'element-ui';
import router from '@/router/index';
import { setCallFn } from './imcall';
import * as $http from '@/axios';
import { MessageBox } from 'element-ui';
import BindPhone from '@/components/BindPhone/index.js';
import MyLog from '@/utils/my-log';
class Base {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    // 默认执行
    /**
     * Date 原型添加 $format 方法
     * new Date().$format('yyyy-MM-dd hh:mm:ss')
     * new Date().$format('yyyy-MM-dd hh:mm')
     * new Date().$format('yyyy-MM-dd hh:mm:ss.S')
     * 可在 chrome 控制台试验查看效果
     */
    // eslint-disable-next-line
    Date = (function(Date) {
      myDate.now = Date.now;
      myDate.parse = Date.parse;
      myDate.prototype = Date.prototype;
      myDate.prototype.$format = function(date) {
        const obj = {
          'M+': this.getMonth() + 1,
          'd+': this.getDate(),
          'h+': this.getHours(),
          'm+': this.getMinutes(),
          's+': this.getSeconds(),
          S: this.getMilliseconds()
        };
        if (/(y+)/.test(date)) {
          date = date.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
          );
        }
        for (let key in obj) {
          if (new RegExp('(' + key + ')').test(date)) {
            date = date.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? obj[key]
                : ('00' + obj[key]).substr(('' + obj[key]).length)
            );
          }
        }
        return date;
      };
      return myDate;
      function myDate() {
        // 当只有一个参数并且参数类型是字符串时，把字符串中的-替换为/
        if (arguments.length === 1) {
          let arg = arguments[0];
          if (
            Object.prototype.toString.call(arg) === '[object String]' &&
            arg.indexOf('T') === -1
          ) {
            arguments[0] = arg.replace(/-/g, '/');
          }
        }
        let bind = Function.bind;
        let unbind = bind.bind(bind);
        // eslint-disable-next-line new-parens
        return new (unbind(Date, null).apply(null, arguments))();
      }
    })(Date);
    this.Login = Login;
    this.setCallFn = setCallFn;
  }

  get nativeType() {
    const UA = navigator.userAgent;
    return UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      ? 'iOS'
      : UA.indexOf('Android') > -1 || UA.indexOf('Linux') > -1
      ? 'android'
      : '';
  }

  // nicee下載地址（客户端商店）
  get AppDownloadUrl() {
    return {
      iOS:
        'https://apps.apple.com/tw/app/nicee-%E6%83%B3%E7%8E%A9%E9%81%8A%E6%88%B2%E5%B0%B1%E7%B4%84%E6%88%91/id1495014289',
      android:
        'https://play.google.com/store/apps/details?id=com.funplus.teamup',
      androidWeb: 'https://nicee.tw/nicee.apk'
    };
  }

  jumpAppStore(type) {
    const typeName = type || this.nativeType;
    if (typeName == 'android') {
      const downloadWindow = window.open(
        this.AppDownloadUrl[typeName],
        '_blank'
      );
      setTimeout(() => {
        try {
          const origin = location.origin;
          if (
            downloadWindow.location &&
            downloadWindow.location.href &&
            downloadWindow.location.href.includes('google')
          ) {
            alert(i18n.t('utils_util_1383'));
          } else {
            alert(i18n.t('utils_util_1384'));
            window.location.href = this.AppDownloadUrl['androidWeb'];
          }
          setTimeout(() => {
            window.location.href = origin;
          }, 5000);
        } catch (error) {
          console.log(error);
        }
      }, 3000);
    } else {
      window.open(this.AppDownloadUrl['iOS'], '_self');
    }
  }

  downloadApp(typeName) {
    if (typeName === 'appleStore') {
      window.open(this.AppDownloadUrl['iOS'], '_blank');
    }
    if (typeName === 'google') {
      window.open(this.AppDownloadUrl['android'], '_blank');
    }
    if (typeName === 'android') {
      window.open(this.AppDownloadUrl['androidWeb'], '_self');
    }
  }

  // 根据 key 返回 url 携带的参数（query string 的 val）
  getUrlParam(key, target) {
    let str = target || window.location.href;
    str = str.split('?')[1];
    if (str && str.indexOf(key) !== -1) {
      const pos1 = str.indexOf(key) + key.length + 1;
      const pos2 = str.indexOf('&', pos1);
      let val = pos2 == -1 ? str.substring(pos1) : str.substring(pos1, pos2);
      try {
        return decodeURIComponent(val);
      } catch (e) {
        const len = val.length - 1;
        if (val.substring(len) == '%') {
          return decodeURIComponent(val.substring(0, len)) + '%';
        }
      }
    }
  }

  // 去除前后空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }

  // 個位數加0
  repaireZero(val) {
    val += '';
    return val.length > 1 ? val : val.length === 1 ? '0' + val : '';
  }

  // 大數字展示
  repaireLongNum(val) {
    val += '';
    if (val.length < 5) {
      return val;
    } else if (val.length < 9) {
      const pos = val.length - 4;
      return i18n.t('utils_util_1385', [val.substring(0, pos),val.substring(pos + 1, pos + 2)]);
    } else {
      const pos = val.length - 9;
      return i18n.t('utils_util_1386', [val.substring(0, pos),val.substring(pos + 1, pos + 2)]);
    }
  }

  // 千位逗号分隔数字
  moneySplit(money) {
    if (!+money) return '0.00';
    let float = money % 1;
    money -= float;
    if (float) {
      float = parseInt(float * 100);
    }
    float < 10 && (float = '0' + float);
    return (
      (money + '')
        .split('')
        .reverse()
        .reduce((result, item, index) => {
          let split = index !== 0 && index % 3 == 0 ? ',' : '';
          return item + split + result;
        }) +
      '.' +
      float
    );
  }

  // 是否在线
  isOnline(item) {
    // const { skillOnlineStatus } = item;
    // if (skillOnlineStatus) {
    //   return skillOnlineStatus === 'WantOrder';//积极接单
    // } else {
    //   return this.onlineTime(item) === '在線';
    // }
    return this.onlineTime(item) === i18n.t('utils_util_1387');
  }

  // 在线状态
  onlineTime({ userOnlineStatus, offlineTime, isIM }) {
    if (userOnlineStatus && userOnlineStatus === 'Online') {
      return i18n.t('utils_util_1387');
    } else {
      if (!offlineTime) return i18n.t('utils_util_1387');
      const diff = Date.now() - offlineTime;
      if (diff <= 0) return '';
      const minutes = Math.floor(diff / 60000);
      if (minutes > 480) {
        // 超過8小時，不顯示任何內容（IM除外）
        if (isIM) {
          if (minutes <= 60 * 24) {
            return Math.floor(minutes / 60) + i18n.t('utils_util_1388');
          } else {
            let days = Math.floor(minutes / (60 * 24)) + i18n.t('utils_util_1389');
            if (days >= 30) return i18n.t('utils_util_1390');
            return days;
          }
        } else {
          return '';
        }
      } else if (minutes > 60) {
        // 1-8小時，狀態顯示”x小時前“
        return Math.floor(minutes / 60) + i18n.t('utils_util_1388');
      } else if (minutes > 0) {
        //   // 30分鐘-1小時，狀態顯示為（關閉的時間-30）分鐘前
        // 1-1小時，線上xx分鍾前
        return minutes + i18n.t('utils_util_1391');
      } else {
        return i18n.t('utils_util_1387');
      }
    }
  }

  // 新人優惠券，未登錄的固定券值
  get newerDiscount() {
    return 20;
  }

  // 返回计算后的价格
  computedPrice(item) {
    let discount = 0;
    const { userInfo, accountInfo } = store.getters;
    if (!userInfo || !accountInfo) {
      discount = this.newerDiscount;
    } else {
      const list = (accountInfo.couponInfoList || []).filter(item => {
        return (
          item.couponTemplate === 'NEWCOMER_EXPERIENCE' &&
          item.couponStatus === 'EFFECT'
        );
      });
      discount = list[0] ? list[0].couponAmount || 0 : 0;
    }
    const { salesPrice, redBagFreeFlag, selfSpreadPrice } = item;
    if (discount) {
      const origin = redBagFreeFlag === 1 ? selfSpreadPrice : salesPrice;
      const result =
        origin - discount == salesPrice
          ? ''
          : Math.max(origin - discount, 0) + '';
      if (result) return result;
    }
    const { firstOrderPrivilege, firstOrderDiscount } = item;
    if (firstOrderPrivilege) {
      return Math.max(salesPrice - firstOrderDiscount, 0);
    }
    return '';
  }

  // 通用标签
  get tagsList() {
    return [
      {
        id: 11,
        label: i18n.t('upgrade_page_views_player_list_index_199')
      },
      {
        id: 15,
        label: i18n.t('upgrade_page_views_player_list_index_200')
      },
      {
        id: 13,
        label: i18n.t('upgrade_page_views_player_list_index_198')
      },
      {
        id: 10,
        label: i18n.t('upgrade_page_views_player_list_index_195')
      },
      {
        id: 16,
        label: i18n.t('upgrade_page_views_player_list_index_201')
      },
      {
        id: 17,
        label: i18n.t('utils_util_1392')
      }
    ];
  }

  // 位置标签
  get gameModelColumn() {
    return [
      {
        value: 'solo',
        text: i18n.t('utils_util_1393')
      },
      {
        value: 'solo-fpp',
        text: i18n.t('utils_util_1394')
      },
      {
        value: 'duo',
        text: i18n.t('utils_util_1395')
      },
      {
        value: 'duo-fpp',
        text: i18n.t('utils_util_1396')
      },
      {
        value: 'squad',
        text: i18n.t('utils_util_1397')
      },
      {
        value: 'squad-fpp',
        text: i18n.t('utils_util_1398')
      }
    ];
  }

  // 返回通用标签，id,name,classes
  computedTags(list, type = 'custom', showNumber = false) {
    // 年度活动标识
    const newYearList = [21, 22, 23, 24, 25, 26, 27];
    if (!list || !list.length) return [];
    const typeRel = {
      custom: {
        10: ['rebought', i18n.t('upgrade_page_views_player_list_index_195')],
        11: ['hot', i18n.t('upgrade_page_views_player_list_index_199')],
        13: ['nice', i18n.t('upgrade_page_views_player_list_index_198')],
        15: ['new', i18n.t('upgrade_page_views_player_list_index_200')],
        16: ['minutes7', i18n.t('utils_util_1399')],
        // 17: ['findBoss', '小天使團'],
        21: ['championOfYear', i18n.t('utils_util_1400')], // 年度冠军
        22: ['runnerUpOfYear', i18n.t('utils_util_1401')], // 年度亚军
        23: ['thirdPlaceOfYear', i18n.t('utils_util_1402')], // 年度季军
        24: ['bossOfYear', i18n.t('utils_util_1403')], // 年度老板
        25: ['quarterfinalsOfYear', i18n.t('utils_util_1404')], // 年度八强
        26: ['grandCeremony', i18n.t('utils_util_1405')], // 盛典
        27: ['hanbokElite', i18n.t('utils_util_1406')] // 韩服精英
        // 14: ['rebought', '回單王'],
      },
      comment: {
        1001: ['top'], // 上單認證
        1002: ['jug'], // 打野認證
        1003: ['mid'], // 中單認證
        1004: ['adc'], // ADC認證
        1005: ['sup'] // 輔助認證
      }
    };
    const tagRel = typeRel[type];
    if (type === 'comment') {
      // 1024...1028
      // 1055...1059
      for (const id in tagRel) {
        tagRel[+id + 23] = tagRel[id];
        tagRel[+id + 54] = tagRel[id];
      }
    }
    const resolveName = (tag, item) => {
      if (showNumber && tag[0] == 'rebought' && item.labelData != undefined) {
        const subfix = ' ' + Math.round(item.labelData * 100) + i18n.t('utils_util_1407');
        return tag[1] + subfix;
      }
      return tag[1] || item.labelName;
    };
    return list.reduce((cuur, item) => {
      const id = +item.labelId;
      const tag = tagRel[id];
      let classes = [];
      if (tag) {
        classes = [`${type}-tag`, tag[0]];
        if (newYearList.includes(id)) {
          classes = [...classes, 'only-show-image'];
        }
      }
      return tag
        ? cuur.concat({
            id,
            name: resolveName(tag, item),
            classes: classes,
            onlyShowIamge: newYearList.includes(id)
          })
        : cuur;
    }, []);
  }

  // 补充list至目标长度
  addListItem(listLen, targetLen) {
    const result = targetLen - (listLen % targetLen);
    return result === targetLen ? 0 : result;
  }

  // 獲取不確定值
  getVal(source, keys) {
    if (!keys) return source;
    if (!Array.isArray(keys)) {
      keys = keys.split('.');
    } else {
      keys = [...keys];
    }
    while (keys.length) {
      if (typeof source !== 'object' || !source) return undefined;
      source = source[keys.shift()];
    }
    return source;
  }

  // 打开新窗口
  openWindow(path = '/', name = null) {
    const { protocol, host } = window.location;
    const sessionVal = window.sessionStorage.getItem('GA_OPTIONS');
    if (sessionVal) {
      const val = JSON.parse(sessionVal);
      if (val) {
        const query = [];
        const prefix = path.indexOf('?') === -1 ? '?' : '&';
        Object.keys(val).forEach(i => {
          query.push(`${i}=${val[i]}`);
        });
        path += prefix + query.join('&');
      }
    }
    const params = [`${protocol}//${host}${path}`];
    if (name) params.push(name);
    let target = window.open.apply(window, params);
    if (!target) return;
    // 用於紀錄上一個頁面，追蹤用戶路徑
    const preRouterName = router.currentRoute.name;
    target.prePageInfo = {
      prepage: location.pathname,
      firstPage: path,
      preRouterName
    };
    if (name) {
      // 路由名字，方便跳轉統計歸類
      const handleInfo = {
        prePage: location.pathname,
        preRouterName,
        firstPage: path
      };
      target.sessionStorage.setItem(
        `PRE_PAGE_${name}`,
        JSON.stringify(handleInfo)
      );
    }
    return target;
  }

  openDashboardWindow(path = '/dashboard') {
    this.openWindow('/player' + path, 'PLAYER_DASHBORD');
  }

  get CHAT_WINDOW_NAME() {
    return 'TEAMUP_CHAT_WINDOW';
  }

  // 打开聊天窗口（默认系统消息（客服））
  async openChatWindow(
    formUserId,
    toUserId = '',
    skillId = -1,
    giftObj,
    modelId
  ) {
    if (Number(toUserId) > 4373700) {
      const { data } = await $http.get('/im/onBefore');
      if (data === 1) {
        MessageBox.confirm(i18n.t('utils_util_1408'), {
          confirmButtonText: i18n.t('utils_util_1409'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          showCancelButton: true,
          customClass: 'el-message-box fps-message-box two-btn',
          showClose: false
        }).then(() => {
          BindPhone();
        });
        return;
      }
      if (data === 2) {
        MessageBox.confirm(i18n.t('utils_util_1410'), {
          confirmButtonText: i18n.t('utils_util_1411'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          showCancelButton: true,
          customClass: 'el-message-box fps-message-box two-btn',
          showClose: false
        }).then(() => {
          window.open('/saving', '_blank');
        });
        return;
      }
    }
    let urlparam = 'chat';
    let query = '';
    if (skillId && skillId !== -1) {
      query += `skillId=${skillId}`;
    }
    if (giftObj) {
      if (query) query += '&';
      query += `giftObj=${encodeURI(JSON.stringify(giftObj))}`;
    }
    if (modelId) {
      if (query) query += '&';
      query += `modelId=${modelId}`;
    }
    const chatWindow = this.openWindow(
      `/${urlparam}/${formUserId}${query ? '?' + query : ''}`,
      this.CHAT_WINDOW_NAME
    );
    if (chatWindow) {
      const origin = location.protocol + '//' + location.host;
      window.addEventListener('message', event => {
        if (event.data === 'LOAD_FINISH' && event.origin === origin) {
          chatWindow.postMessage(
            {
              type: 'CHAT_TO_USER_ID',
              data: toUserId
            },
            origin
          );
        }
      });
    }
  }

  /**
   * @description: 防抖
   * @param {*} handleFn 执行函数 time 抖动间隔
   * @return {*} function
   */
  debounce(handleFn, time) {
    let starTime = new Date().getTime();
    let timeOut;
    return function dd() {
      let arg = [...arguments];
      let nowTime = new Date().getTime();
      if (nowTime - starTime < time) {
        clearTimeout(timeOut);
      }
      starTime = nowTime;
      timeOut = setTimeout(() => {
        handleFn.call(this, ...arg);
      }, time);
    };
  }

  /**
   * @description: 截流
   * @param {*}
   * @return {*}
   */
  throttle(handleFn, time) {
    let starTime = new Date().getTime();
    // 保证最后一次和最后一次的执行的执行
    let dd = this.debounce(handleFn, time);
    return function tt() {
      let arg = [...arguments];
      let nowTime = new Date().getTime();
      if (nowTime - starTime >= time) {
        handleFn.call(this, ...arg);
        starTime = nowTime;
      } else {
        dd.call(this, ...arg);
      }
    };
  }

  /**
   * @description: 是否在视窗内可见
   * @param {*} el dom
   * @return {*}
   */
  isViewVisible(el, bottom = 0) {
    const offset = el.getBoundingClientRect();
    const offsetTop = offset.top;
    const offsetBottom = offset.bottom;
    // 进入可视区域
    if (offsetTop <= window.innerHeight && offsetBottom >= bottom) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * @description: copy
   * @param {*}
   * @return {*}
   */
  copyText(text) {
    const input = document.createElement('textarea');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length),
      document.execCommand('Copy');
    document.body.removeChild(input);
    Message.success(i18n.t('components_userinfo_uuid_218'));
  }

  isJSONStringifiable(variable) {
    try {
      JSON.stringify(variable);
      return true;
    } catch (error) {
      return false;
    }
  }

  captureException(errorName, tags, response) {
    MyLog.bugsnagNotify(errorName, {
      tags:tags,
      context: response
    });
    try {
      const { userInfo } = store.getters;

      const errorData = {
        errorName,
        tags,
        uuid: userInfo && userInfo.uuid ? userInfo.uuid : '',
        pathname: location.pathname,
        response:
          typeof response === 'string'
            ? response
            : this.isJSONStringifiable(response)
            ? response
            : ''
      };
      $http.post('/basic/front/error', {
        message: JSON.stringify(errorData)
      });
    } catch (error) {
      console.log(error);
    }
  }

  // 设置图片大小
  setImageSize(url, width, height) {
    if (url) {
      url = url.replace('.gif', '.png');
      return url + `?d=${width}x${height}`;
    } else {
      return '';
    }
  }
}

export default new Base();
